import type { OrganizationDocumentResponse } from '@acme/api';
import { OrganizationService } from '@acme/api/client';
import { formatDate } from '@acme/foundation';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';
import {
  DownloadButton,
  getDownloadFilename,
  useDocumentDownload,
} from '../../lib';

export type OrganizationDocumentsTableProps = {
  documents: OrganizationDocumentResponse[];
};

export const OrganizationDocumentsTable = ({
  documents,
}: OrganizationDocumentsTableProps) => {
  const { downloadingId, handleDownloadClick } =
    useDocumentDownload<OrganizationDocumentResponse>({
      fetchBlob: (id) =>
        OrganizationService.getApiV1OrganizationFiles({ fileId: id }),
      getDocId: (doc) => doc.id,
      getFilename: (doc) => getDownloadFilename(doc),
    });

  if (documents.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-12 text-center text-gray-500">
        Документы не найдены
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <Table>
          <TableHead className="bg-gray-50">
            <TableRow>
              <TableHeadCell></TableHeadCell>
              <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                Название
              </TableHeadCell>
              <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                Тип
              </TableHeadCell>
              <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                Дата загрузки
              </TableHeadCell>
              <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                Срок действия
              </TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody className="divide-y divide-gray-200">
            {documents.map((doc) => (
              <TableRow key={doc.id} className="bg-white hover:bg-gray-50">
                <TableCell className="py-4 px-4 text-sm text-gray-900">
                  <div className="flex items-center justify-center gap-2">
                    <DownloadButton
                      docId={doc.id}
                      downloadingId={downloadingId}
                      onDownload={(e) => handleDownloadClick(e, doc)}
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <span>{doc.name ?? '—'}</span>
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-gray-900">
                  {doc.documentTypeName ?? '—'}
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-gray-900 whitespace-nowrap">
                  {formatDate(doc.uploadDate)}
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-gray-900 whitespace-nowrap">
                  {formatDate(doc.expireDate)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
